import React from 'react';
import './Services.css';
import { Link } from 'react-router-dom';

function Services() {
  // Service cards data
  const serviceCards = [
    {
      id: 1,
      image: '/Pics/Services1.jpg',
      title: 'Full Logistics',
      description: 'Tailored answers for your distinct and intricate logistics requirements..',
      link: '/fulllogistic'
    },
    {
      id: 2,
      image: '/Pics/Services2.jpg',
      title: 'Sea Freight',
      description: 'Economical ocean freight forwarding by experienced shipping professionals..',
      link: '/seafreight'
    },
    {
      id: 3,
      image: '/Pics/Services3.jpg',
      title: 'Cargo',
      description: 'The effectiveness of warehouse and logistics solutions.. ',
      link: '/cargo'
    },
    {
      id: 4,
      image: '/Pics/Services4.jpg',
      title: 'Road',
      description: 'Enhance proficiency with high-caliber road freight solutions and a dynamic team..',
      link: '/road'
    },
    {
      id: 5,
      image: '/Pics/Services5.jpg',
      title: 'Air Freight',
      description: 'Secured air freight options, managed with precision for a hassle-free experience.. ',
      link: '/airfreight'
    },
    {
      id: 6,
      image: '/Pics/Lcl.jpg',
      title: 'LCL Consolidation & Warehousing',
      description: 'Centrex Marine Services is a trusted logistics provider, offering a comprehensive range.. ',
      link: '/lcl'
    }
  ];

  return (
    <div className="main-services-container">
      {/* Hero section with image and overlay text */}
      <div className="services-hero">
        <div className="services-overlay">
          <h1>Services</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
      
      {/* Services content */}
      <div className="services-content">
        <div className="services-description">
          <p>
            Centrex marine services's supply chain solutions are backed up by the extensive experience garnered from past ventures and the well-developed analytical skills honed over time. The processes we go by possess a deep understanding of how the internal operational protocols function, grasping the logistical requirements of both our clients and supply chain collaborators and then implementing ongoing enhancement strategies to guarantee that the entire cycle assures delivery of top-notch services only to our clients.
          </p>
          
          <p>
            The team of <Link to="/" className="highlight-text">Centrex marine services </Link> has always worked hard and long to achieve the set standardized guidelines and requirements of freight forwarding and logistic solutions all over the world. Hence it is immense pride we take in catering our clientele with world-class quality supply chain solutions that are dependable.
          </p>
          <h2 className="services-title">WE OFFER</h2>
        </div>
        
        {/* Service Cards */}
        <div className="service-cards-container">
          {serviceCards.map(card => (
            <div className="service-card" key={card.id}>
              <div className="service-card-image-container">
                <img  loading="lazy" src={card.image} alt={card.title} className="service-card-image" />
              </div>
              <div className="service-card-content">
                <div className='service-card-title'>
                  <h3 className="service-card-title-h3">{card.title}</h3>
                </div>
                <p className="service-card-description">{card.description}</p>
                <Link to={card.link} className="service-card-button">
                  Read More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="white-gap"></div>
    </div>
  );
}

export default Services;
